<template>
  <v-row justify="center">
    <v-dialog v-model='selectproductmodal' max-width="900">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="cancel()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout justify-center>
            <v-flex xs11 sm11 md11 lg11 pt-4>
              <v-layout>
                <v-flex xs12 sm6 md4 lg4 >
                  <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสซื้อขาย</strong></p>
                  <v-text-field v-model="productno_search" outlined clearable dense v-on:input="productfilterfunction()" color="pink lighten-3"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md5 lg5 px-5>
                  <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อสินค้า</strong></p>
                  <v-text-field v-model="name_search" outlined clearable dense v-on:input="productfilterfunction()" color="pink lighten-3"></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="allproductdata_view"
                class="elevation-1"
                item-key="_id"
                show-select
                :loading="loading"
                :items-per-page="5"
                :footer-props="{
                  itemsPerPageOptions: [5, 10, 20, 50, 100]
                }"
              >
              <template v-slot:item.image="{ item }">
                <v-img
                  class="white--text align-center"
                  style="height:70px; width:100px;"
                  :src="item.image"
                  v-if="item.image"
                ></v-img>
              </template>
              <template v-slot:item.price="{ item }">
                <br /><v-text-field class="centered-input" solo v-model="item.price" type="number" step="any" min="0"></v-text-field>
              </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        <br />
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import axios from 'axios'
import numeral from 'numeral'
export default {
  data () {
    return {
      title: 'รายการสินค้า',
      allproductdatas: [],
      allproductdata_view: [],
      headers: [
        { text: 'รหัสซื้อขาย', align: 'center', sortable: false, value: 'product_no' },
        { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
        { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
        { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
        { text: 'ประเภท', align: 'center', sortable: false, value: 'type' }
      ],
      selected: [],
      loading: false,
      productno_search: '',
      name_search: ''
    }
  },
  methods: {
    async save () {
      try {
        this.selected = this.selected.map(select => {
          let chk = this.allproductdata_view.filter(pd => String(pd._id) === String(select._id))
          if (chk.length !== 0) {
            select.price = numeral(chk[0].price).format('0.00')
          }
          return { ...select }
        })
        this.currentgrouppricedata = JSON.stringify(this.selected)
        this.selectproductmodal = false
      } catch (error) {
      }
    },
    async getallproductdata () {
      try {
        this.loading = true
        let { data } = await axios.get(`${process.env.VUE_APP_API}/product/get`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.allproductdatas = data.map(pd => {
          pd.image = pd.image ? `${process.env.VUE_APP_API}${pd.image}` : ''
          pd.price = numeral(pd.price).format('0.00')
          return { ...pd }
        })
        this.allproductdata_view = this.allproductdatas
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    cancel () {
      this.selectproductmodal = false
    },
    productfilterfunction () {
      this.allproductdata_view = this.allproductdatas.filter(product => {
        let condition = [
          this.productno_search ? (product.product_no.toLowerCase()).includes((this.productno_search).toLowerCase()) : true,
          this.name_search ? (product.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true
        ]
        return condition.every(con => con)
      })
    }
  },
  computed: {
    selectproductmodal: sync('selectproductmodal'),
    currentgrouppricedata: sync('currentgrouppricedata')
  },
  watch: {
    currentgrouppricedata () {
      this.selected = JSON.parse(this.currentgrouppricedata)
      this.allproductdatas = this.allproductdatas.map(pd => {
        let chk = this.selected.filter(sel => sel._id === pd._id)
        if (chk.length !== 0) {
          pd.price = numeral(chk[0].price).format('0.00')
        }
        return { ...pd }
      })
    }
  },
  created () {
    this.getallproductdata()
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.inputstyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
}
.v-text-field {
  font-family: 'Kanit';
}
.v-data-table {
  font-family: 'Kanit';
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.centered-input input {
  text-align: center
}

</style>

<style scoped>
td {
  max-width: 90px !important;
  overflow: hidden !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}
</style>
